import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Ticket } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { clientLoginToken, vendorLoginToken } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const role = localStorage.getItem("kn_oauth_role") || "client";
    const back = localStorage.getItem("kn_oauth_return") || (role === "vendor" ? "/vendor" : "/");

    if (!sid) { navigate("/"); return; }

    const path = role === "vendor" ? "/auth/google" : "/client/auth/google";
    api.post(path, { session_id: sid })
      .then((r) => {
        if (role === "vendor") vendorLoginToken(r.data);
        else clientLoginToken(r.data);
        localStorage.removeItem("kn_oauth_role");
        localStorage.removeItem("kn_oauth_return");
        window.history.replaceState(null, "", back);
        toast.success("Accesso con Google effettuato");
        navigate(back, { replace: true });
      })
      .catch((err) => {
        localStorage.removeItem("kn_oauth_role");
        localStorage.removeItem("kn_oauth_return");
        setError(err?.response?.data?.detail || "Autenticazione con Google non riuscita. Riprova.");
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6">
      <div className="h-14 w-14 rounded-2xl kn-gradient flex items-center justify-center mb-4">
        <Ticket className="h-7 w-7 text-white" />
      </div>
      {error ? (
        <>
          <p className="text-slate-700 font-bold text-center">{error}</p>
          <button onClick={() => navigate("/")} className="mt-4 text-[#E63946] font-bold">Torna alla home</button>
        </>
      ) : (
        <div className="flex items-center gap-2 text-slate-500 font-semibold">
          <Loader2 className="h-5 w-5 animate-spin" /> Accesso in corso...
        </div>
      )}
    </div>
  );
}
